import { BrowserAdapter } from "./adapter.mjs";
import "./ICanvas.mjs";
import "./ICanvasRenderingContext2D.mjs";
import { settings } from "./settings.mjs";
import { isMobile } from "./utils/isMobile.mjs";
export {
  BrowserAdapter,
  isMobile,
  settings
};
//# sourceMappingURL=index.mjs.map
